import styled from 'styled-components';


const Span = styled.span`
    width: 50px;
    height: 40px;
    border-radius: 9px 0px 0px 9px;
    border-right: 2px solid #00273F;
`;


export default Span;
